/**
 * 処分業者
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/drivers`

 const allocate_entry_driver = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 配車計画 ドライバー一覧
     * @param commit
     * @param target_date
     * @returns {Promise<unknown>}
     */
    index ({ commit }, { target_date }) {
      const params = { target_date: target_date }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},

 }

 export default allocate_entry_driver
